import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PaginatorState } from 'src/app/shared/components/paginator/paginator.module';
import { GameListItem } from 'src/app/shared/interfaces/game.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { MiniGameService } from '../minigame.service';

@UntilDestroy()
@Component({
  selector: 'app-game-recent-played',
  templateUrl: './game-recent-played.component.html',
  styleUrls: ['./game-recent-played.component.scss'],
})
export class GameRecentPlayedComponent implements OnInit {
  constructor(
    private layout: LayoutService,
    private miniGameService: MiniGameService,
  ) {}

  games: GameListItem[] = [];
  loading: boolean = true;

  //分页器
  paginator: PaginatorState = {
    page: 1,
    pageSize: 24, // 每页24个
    total: 0,
  };

  updatedFavoriteIds = this.miniGameService.allFavoriteIds$.pipe(untilDestroyed(this)).subscribe(ids => {
    if (!this.games) return;
    this.games.forEach((item: GameListItem) => {
      item.isFavorite = ids.includes(item.id);
    });
  });

  ngOnInit() {
    this.getRecentLyPlayedList(true);
  }

  getRecentLyPlayedList(init: boolean) {
    this.loading = true;
    this.miniGameService.getRecentLyPlayedGame(this.paginator.page, this.paginator.pageSize).subscribe(data => {
      if (data) {
        this.loading = false;
        this.paginator.total = data.total;
        if (data.list) {
          if (init) {
            this.games = data.list;
          } else {
            this.games.push(...data.list);
          }
        }
      }
    });
  }

  breakpoint = 0;
  initBreakpoint(on: boolean, el: HTMLDivElement) {
    if (!on) return;
    this.layout
      .getBreakpoint(el)
      .pipe(untilDestroyed(this))
      .subscribe(x => {
        this.breakpoint = x as number;
      });
  }
}
